import React from 'react';

import Coachmark from '../coachmark/coachmark';

import styles from './full-screen-cta.module.scss';

function FullScreenCta() {
  return (
    <div className={styles.fullScreenCtaContainer}>
      <Coachmark
        position="left"
        showArrow={true}
        label="For the best experience, view activity in full screen."
      />
    </div>
  );
}

export default FullScreenCta;
